import * as React from 'react'

export const copyObject = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}

const Colors = {
    red: "#cc0000",
    green: "#198c19",
    orange: "#ffc107",
}
const initState = {
    seconds: 0,
    minutes: 0,
    hours: 0,
    secondsText: 0,
    check_in: "",
    show: false,
    stop: false,
    start: 0,
    duration: 0,
    isRunning: false,
}

/**
 * 
 * @param callback 
 * @param delay 
 */
function useInterval(callback, delay) {
    const intervalId = React.useRef(null);
    const savedCallback = React.useRef(callback);
    React.useEffect(() => {
        savedCallback.current = callback;
    });
    React.useEffect(() => {
        const tick = () => savedCallback.current();
        if (typeof delay === 'number') {
            intervalId.current = window.setInterval(tick, delay);
            return () => window.clearInterval(intervalId.current);
        }
    }, [delay]);
    return intervalId.current;
}


export interface ITimerViewProps {
    autoPlay?: boolean
    mode?: "increase" | "minus"
    duration?: number
    show?: boolean
    onChangeDuration?(duration: number): void
    stoped?(): void
    ref?: React.RefObject<HTMLInputElement>;
}

export interface ITimerViewHandles {
    start(): void;
    stop(): void
}

const TimerView = React.forwardRef((props: ITimerViewProps, ref) => {
    const [state, setState] = React.useState(initState);
    const [status, setStatus] = React.useState('idle');
    const countDown = React.useRef(null);


    useInterval(
        () => {
            updateUi()
        },
        status === "running" ? 1000 : null
    );


    React.useImperativeHandle(ref, () => ({
        start: () => {
            start()
        },
        stop: () => {
            stop()
        },
        puase: () => {
            puase()
        },
        resume: () => {
            resume()
        },
        rest: () => {
            rest()
        },
        show: () => {
            show()
        },
        hidden: () => {
            hidden()
        },
    }), []);



    React.useEffect(() => {
        initLoad()

        if (props.autoPlay) {
            start()
        }
        return () => {


        }
    }, []);


    React.useEffect(() => {
        initLoad()

    }, [props.duration]);


    React.useEffect(() => {
        if (props.show != null) {
            setState(state => {
                state.show = props.show
                return state
            })
        }

    }, [props.show]);


    const toggle = () => {

        setStatus((status) => (status === 'running' ? 'idle' : 'running'));
    };


    const initLoad = () => {

        if (props.mode == "minus") {
            if (state.duration != props.duration) {
                setState({
                    ...state, ...{
                        seconds: parseFloat(`${props.duration}`),
                        duration: parseFloat(`${props.duration}`)
                    }
                })
            }
        }
    }


    const updateState = (key, value) => {
        let cloneState = copyObject(state)
        cloneState[key] = value
        setState(cloneState)
    }

    const stop = () => {

        if (props.stoped) {
            props.stoped()
        }

        setStatus("idle");
    }

    const start = () => {

        if (!isRunning()) {
            setStatus("running");
        }
    }

    const puase = () => {
        setStatus("idl");
        // updateState("isRunning", false)

    }
    const resume = () => {
        setStatus("running");
        // updateState("isRunning", true)

    }

    const show = () => {
        setState(state => {
            state.show = true
            return state
        })
    }
    const hidden = () => {
        setState(state => {
            state.show = false
            return state
        })
    }
    const rest = () => {
        setState({ ...initState })
    }

    const checkIsDone = () => {
        const { seconds } = state;
        if (seconds <= 0) {
            stop();
            //clearInterval(countDown.current)
            return false;
        }
        return true;
    }

    const isRunning = () => {
        return status === "running"
    }

    const updateUi = () => {

        const { seconds } = state;

        if (!isRunning()) {
            return null;
        }
        if (props.mode == "minus") {
            if (!checkIsDone()) {
                return null;
            }
        }
        const newSeconds = props.mode == "increase" ? seconds + 1 : seconds <= 0 ? 0 : seconds - 1;

        setState({
            ...state, ...{
                seconds: newSeconds,
                duration: newSeconds,
                show: props.show != null ? props.show : true,
                minutes: Math.abs(parseInt(((seconds / 60) % 60).toString(), 10)),
                hours: Math.abs(parseInt(((seconds / 60 / 60) % 60).toString(), 10)),
                secondsText: Math.abs(parseInt((seconds % 60).toString(), 10))
            }
        })

        if (props.onChangeDuration) {
            props.onChangeDuration(newSeconds)
        }

    }




    const formatColor = () => {

        if (props.mode == "minus") {
            const fiveMin = 60 * 5
            const seconds = Math.abs(state.seconds);
            if (seconds > fiveMin) {
                return Colors.green
            } else if (seconds < fiveMin && seconds >= 60) {
                return Colors.orange
            } else if (seconds < 60) {
                return Colors.red;
            }
        }

        return "#000"
    }

    if (!state.show) return null;

    return (
        <div style={{
            // backgroundColor: "#fff",
             padding: 0,
            alignContent: 'center', justifyContent: 'center', alignItems: 'center'
        }}>

            <span style={{ color: formatColor(), fontSize: 50 }}>
                {state.hours > 0 ? state.hours + ":" : null}{parseFloat(`${state.minutes}`).toFixed(0)}:{state.secondsText < 10 ? '0' + state.secondsText : state.secondsText}
            </span>
        </div>
    )
})

TimerView.defaultProps = {
    mode: "increase",// increase|| minus
    autoPlay: false,
    duration: 0,
}
export default TimerView;